import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const UseStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      minHeight: '50px',
      marginBottom: '8px',
    },
    header: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      margin: 0,
    },
    subheader: {
      color: theme.palette.primary.contrastText,
    },
    icon: {
      color: 'white',
    },
    content: {
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
    }
  }));

export default UseStyles;
